import { setHelmetConfigurations } from '@mongez/react-helmet';

setHelmetConfigurations({
  appName: 'My Online Store',
  appendAppName: true,
  appNameSeparator: ' | ',
});